import { Box, Grid, useTheme, useMediaQuery, IconButton } from "@material-ui/core"
import NCText from "../../shared/NCText"
import NCInput from "../../shared/NCInput"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useGetRideDetails } from "../../services/queries"
import { TABLE_CONFIG, SEARCH_CONFIG } from "../../libs/config"
import NCTable from "../../shared/table/NCTable"
import NotificationAlert from "../../components/notification/NotificationAlert"
import { SearchIcon, DetailIcon } from "../../libs/icons"
import useDebounce from "../../libs/hooks/Debounce"
import { useTranslation } from "react-i18next"
import NCCalendarButton from "../../shared/NCCalendarButton"
import moment from "moment"

const CANCELLED_STATUSES = [9, 10, 12, 13, 15]
// 9=DRIVER, 10=CLIENT, 12=BEFORE_DRIVER_ASSIGN, 13=REJECTED_BY_DRIVER, 15=PORTAL

const CancelledRides = () => {
  const { t } = useTranslation();
  const nav = useNavigate()
  const [page, setPage] = useState(1)
  const [query, setQuery] = useState("")
  const [pageSize, setPageSize] = useState(TABLE_CONFIG.PAGE_SIZE)
  const [ordering, setOrdering] = useState("-created")
  // Default the filter to today so the page loads today's cancelled rides
  // (instead of every ride) on first load and on refresh.
  const [selectedDate, setSelectedDate] = useState(() => {
    const m = moment()
    return { start: m.startOf("day").format(), end: m.endOf("day").format() }
  })
  const debouncedSearchTerm = useDebounce(query, SEARCH_CONFIG.TIME_IN_MILLI)

  const mobileTheme = useTheme()
  const isSmallScreen = useMediaQuery(mobileTheme.breakpoints.down("sm"))

  const { isLoading, data } = useGetRideDetails({
    page,
    page_size: pageSize,
    search: debouncedSearchTerm || undefined,
    status: CANCELLED_STATUSES.join(","),
    ongoing: "false",
    ordering,
    ...(selectedDate ? {
      start_time: selectedDate.start,
      end_time: selectedDate.end
    } : {})
  })

  const { next, previous, total_pages, results = [] } = data?.data?.data || {}

  const onNext = () => setPage(prev => (next ? prev + 1 : prev))
  const onPrev = () => setPage(prev => (previous ? prev - 1 : prev))

  const getClientName = (trip) => trip.client?.name || trip.name || "-"
  const getDriverName = (trip) => trip.driver?.name || "-"
  const getAmName = (trip) => trip.aid_monitor?.name || "-"
  const getCancelledBy = (trip) => trip.cancelled_by_name || "-"

  const columns = [
    {
      Header: t("Service Date"),
      id: "service_date",
      accessor: cell => cell.pickup_time ? cell.pickup_time.split("T")[0] : "-",
    },
    {
      Header: t("Trip ID"),
      id: "trip_id",
      accessor: cell => `#${cell.id}`,
    },
    {
      Header: t("Client"),
      id: "client",
      accessor: cell => getClientName(cell),
    },
    {
      Header: t("Driver"),
      id: "driver",
      accessor: cell => getDriverName(cell),
    },
    {
      Header: t("A/M"),
      id: "aid_monitor",
      accessor: cell => getAmName(cell),
    },
    {
      Header: t("Cancelled By"),
      id: "cancelled_by",
      accessor: cell => getCancelledBy(cell),
    },
    {
      Header: "",
      id: "action",
      disableSortBy: true,
      accessor: cell => (
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={() => nav(`/cancelled-rides/${cell.id}`)}>
            <DetailIcon />
          </IconButton>
        </Box>
      ),
    },
  ]

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box mb={2}>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={4}>
              {!isSmallScreen ? (
                <NCText variant={"h4"}>{t("Cancelled Rides")}</NCText>
              ) : (
                <Grid container justifyContent="space-between">
                  <Grid item style={{ paddingLeft: "0" }}>
                    <NCText variant={"h4"}>{t("Cancelled Rides")}</NCText>
                  </Grid>
                  <Grid item style={{ paddingLeft: "0" }}>
                    <NotificationAlert />
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container spacing={2} justifyContent={isSmallScreen ? "flex-start" : "flex-end"}>
                <Grid item>
                  <NCInput
                    value={query}
                    onChange={e => {
                      setPage(1)
                      setQuery(e.target.value)
                    }}
                    placeholder={t("common.search_here")}
                    startIcon={SearchIcon}
                    className="rounded"
                  />
                </Grid>
                {!isSmallScreen && (
                  <Grid item style={{ paddingLeft: "0" }}>
                    <NotificationAlert />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Grid container justifyContent="flex-end" mb={2}>
          <Box>
            <NCCalendarButton
              selectedDate={date => {
                setPage(1)
                if (date) {
                  const m = moment(date)
                  setSelectedDate({
                    start: m.startOf("day").format(),
                    end: m.endOf("day").format()
                  })
                } else {
                  setSelectedDate(null)
                }
              }}
            />
          </Box>
        </Grid>
        <NCTable
          columns={columns}
          data={results || []}
          page={page}
          onNext={onNext}
          onPrev={onPrev}
          pageCount={total_pages}
          gotoPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          sorting={ordering}
          setSorting={setOrdering}
          isLoading={isLoading}
        />
      </Grid>
    </Grid>
  )
}

export default CancelledRides
